export default {
  install(Vue, options) {
    /**
     * 替换文案
     */
    Vue.filter("multiReplace", function(value, replacements) {
      if(!value) return "";
      for (var i = 0; i < replacements.length; i++) {
        var charToReplace = replacements[i][0];
        var charToReplaceWith = replacements[i][1];
        value = value.replace(
          new RegExp(charToReplace, "g"),
          charToReplaceWith
        );
      }
      return value;
    });
  }
};



// WEBPACK FOOTER //
// ./src/common/filter.js